import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

// Components
import Layout from './components/Layout';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Project from './pages/Project';
import User from './pages/User';
import Printer from './pages/Printer';
import WebHooks from './pages/WebHooks';
import GeoFence from './pages/GeoFence';
import Devices from './pages/Devices';
import Account from './pages/Account';
import Warehouse from './pages/Warehouse';
import Rules from './pages/Rules';
import FloorPlan from './pages/FloorPlan';
import AuditTrail from './pages/AuditTrail';
import { useStateValue } from './ContextApi/StateProvider';
import EditOrganization from './pages/EditOrganization';
import Zone from './pages/Zone';

const App = () => {
  const [{ user }, dispatch] = useStateValue();
  return (
    <Router>
      <Layout>
        <Switch>
          <Route exact path="/">
            {user ? <Dashboard /> : <Login />}
          </Route>
          <Route exact path="/dashboard">
            <Dashboard />
          </Route>
          <Route exact path="/organization">
            <EditOrganization />
          </Route>
          <Route exact path="/warehouses">
            <Warehouse />
          </Route>
          <Route exact path="/projects">
            <Project />
          </Route>
          <Route exact path="/users">
            <User />
          </Route>
          <Route exact path="/printers">
            <Printer />
          </Route>
          <Route exact path="/devices">
            <Devices />
          </Route>
          <Route exact path="/webhooks">
            <WebHooks />
          </Route>
          <Route exact path="/rules">
            <Rules />
          </Route>
          <Route exact path="/audit-trail">
            <AuditTrail />
          </Route>
          <Route exact path="/floorPlan">
            <FloorPlan />
          </Route>
          <Route exact path="/account">
            <Account />
          </Route>
          <Route exact path="/geofence">
            <GeoFence />
          </Route>
          <Route exact path="/zones">
            <Zone />
          </Route>
        </Switch>
      </Layout>
    </Router>
  );
};

export default App;
